/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Entityids1Inputs */

const en_entity_entityids1 = /** @type {(inputs: Entity_Entityids1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity IDs`)
};

const de_entity_entityids1 = /** @type {(inputs: Entity_Entityids1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitäten-IDs`)
};

/**
* | output |
* | --- |
* | "Entity IDs" |
*
* @param {Entity_Entityids1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_entityids1 = /** @type {((inputs?: Entity_Entityids1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Entityids1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_entityids1(inputs)
	return de_entity_entityids1(inputs)
});
export { entity_entityids1 as "entity_entityIds" }